/**
 * Storefront IIFE entry: reads `window.BirdsviewTrackingConfig`, wires
 * {@link Shopware66Adapter} + {@link TrackingClient} and starts tracking.
 * Vite builds this into `public/static/birdsview-tracking/bv-tracking.js`,
 * loaded via a <script> tag (see product-detail/meta.html.twig). Shopware's
 * storefront webpack never compiles it — the plugin ships no storefront entry.
 */
import { TrackingClient } from './TrackingClient';
import { Shopware66Adapter } from './adapters/Shopware66Adapter';
import { TrackingDebugService } from './services/TrackingDebugService';
import {
  BrowserDomEventService,
  BrowserFetchService,
  BrowserLocationService,
  BrowserTimerService,
} from './services/browser';

declare global {
  interface Window {
    BirdsviewTrackingConfig?: {
      apiUrl: string;
      /** Full storefront domain URL for this page; forwarded to the tracking API as `?domain=` for project resolution (INT-225). */
      storefrontUrl?: string;
    };
  }
}

const cfg = window.BirdsviewTrackingConfig;
const debug = new TrackingDebugService();

debug.log('bootstrap', 'storefront tracking loaded', {
  hasApiUrl: !!cfg?.apiUrl,
});

if (cfg?.apiUrl) {
  const adapter = new Shopware66Adapter(
    new BrowserFetchService(),
    new BrowserDomEventService(),
    new BrowserTimerService(),
    new BrowserLocationService(),
    debug,
    cfg.storefrontUrl,
  );

  const client = new TrackingClient({
    apiUrl: cfg.apiUrl,
    storefrontUrl: cfg.storefrontUrl,
    adapter,
    debug,
  });

  client.init();
}
